import React from 'react';
import { theme, css } from 'constants';
import { View, Text, Link, WebBrowser } from 'core';
import { lang } from 'lang';
import { IcoLocation } from 'icons';

const styles = css({
  holder: {
    padding: 15
  },
  container: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    borderBottomColor: theme.gray_color_lighten(0.4),
    borderBottomWidth: theme.hairline,
    padding: 10
  },
  link: {
    paddingTop: 10,
    justifyContent: 'center',
    alignItems: 'center'
  },
  txt_btn: {
    color: theme.primary_color
  }
});

export const Location = ({ current_msg }) => {
  const { data } = current_msg;
  const { address, latitude, longitude } = data;
  const { city, street, name } = address;

  return (
    <View style={styles.holder}>
      <View style={styles.container}>
        <IcoLocation color="#EA4335" selected size={50} />
        <Text ellipsizeMode={'tail'} numberOfLines={3}>
          {address ? `${(name && name + ',') || ''} ${city || ''} ${(street && ' ,' + street) || ''}` : `${latitude}, ${longitude}`}
        </Text>
      </View>
      <View>
        <Link
          style={styles.link}
          onPress={() => {
            WebBrowser.goToUrl(`https://maps.google.com/?q=${latitude},${longitude}`);
          }}
        >
          <Text style={styles.txt_btn}>{lang.VIEW}</Text>
        </Link>
      </View>
    </View>
  );
};



// WEBPACK FOOTER //
// ./src/components/middle/chat/msgs/location.js